import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "className", "size", "onEdit", "hideAdd", "centered", "addIcon", "tabFixed", "moreMode", "tabFull"];
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import classNames from "classnames";
import RcTabs from "./rc-tabs";
import TabPane from "./rc-tabs/TabPanelList/TabPane";
import * as React from "react";
import { ConfigContext } from "../../ConfigProvider";
import SizeContext from "../../ConfigProvider/SizeContext";
import warning from "../../hack/_util/warning";
import { jsx as _jsx } from "react/jsx-runtime";
function Tabs(_ref) {
  var type = _ref.type,
    className = _ref.className,
    propSize = _ref.size,
    _onEdit = _ref.onEdit,
    hideAdd = _ref.hideAdd,
    centered = _ref.centered,
    addIcon = _ref.addIcon,
    tabFixed = _ref.tabFixed,
    moreMode = _ref.moreMode,
    tabFull = _ref.tabFull,
    props = _objectWithoutProperties(_ref, _excluded);
  var customizePrefixCls = props.prefixCls,
    _props$moreIcon = props.moreIcon,
    moreIcon = _props$moreIcon === void 0 ? /*#__PURE__*/_jsx(EllipsisOutlined, {}) : _props$moreIcon;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var prefixCls = getPrefixCls("tabs", customizePrefixCls);
  var editable;
  if (type === "editable-card") {
    editable = {
      onEdit: function onEdit(editType, _ref2) {
        var key = _ref2.key,
          event = _ref2.event;
        _onEdit === null || _onEdit === void 0 ? void 0 : _onEdit(editType === "add" ? event : key, editType);
      },
      removeIcon: /*#__PURE__*/_jsx(CloseOutlined, {}),
      addIcon: addIcon || /*#__PURE__*/_jsx(PlusOutlined, {}),
      showAdd: hideAdd !== true
    };
  }
  var rootPrefixCls = getPrefixCls();
  warning(!("onPrevClick" in props) && !("onNextClick" in props), "Tabs", "`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.");
  return /*#__PURE__*/_jsx(SizeContext.Consumer, {
    children: function children(contextSize) {
      var _classNames;
      var size = propSize !== undefined ? propSize : contextSize;
      return /*#__PURE__*/_jsx(RcTabs, _objectSpread(_objectSpread({
        direction: direction,
        moreTransitionName: "".concat(rootPrefixCls, "-slide-up")
      }, props), {}, {
        className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), ["card", "editable-card"].includes(type)), _defineProperty(_classNames, "".concat(prefixCls, "-editable-card"), type === "editable-card"), _defineProperty(_classNames, "".concat(prefixCls, "-centered"), centered), _defineProperty(_classNames, "".concat(prefixCls, "-button"), ["button", "button-group"].includes(type)), _defineProperty(_classNames, "".concat(prefixCls, "-button-group"), type === "button-group"), _defineProperty(_classNames, "".concat(prefixCls, "-text"), type === "text"), _defineProperty(_classNames, "".concat(prefixCls, "-fixed"), tabFixed), _defineProperty(_classNames, "".concat(prefixCls, "-tab_fill"), tabFull), _defineProperty(_classNames, "".concat(prefixCls, "-slide"), moreMode === "slide"), _classNames), className),
        editable: editable,
        moreIcon: moreIcon,
        moreMode: moreMode,
        prefixCls: prefixCls
      }));
    }
  });
}
Tabs.TabPane = TabPane;
export default Tabs;